/**
 * Over Visualization — renders the current over as a row of pills (W / 4 / 6 / 1 / • / Wd / Nb).
 * Each pill is clickable (for future ball-edit support in Batch 3).
 */
export default function OverVisualization({ balls, onBallClick }) {
  if (!balls || balls.length === 0) {
    return (
      <div className="text-xs text-gray-400 italic text-center py-2">
        This over will appear here ball-by-ball.
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="over-visualization">
      {balls.map(b => {
        let label = String(b.runs_scored || 0);
        let cls = 'bg-gray-100 text-gray-700';
        if (b.is_wicket) { label = 'W'; cls = 'bg-red-500 text-white'; }
        else if (b.is_boundary_six) { label = '6'; cls = 'bg-purple-500 text-white'; }
        else if (b.is_boundary_four) { label = '4'; cls = 'bg-blue-500 text-white'; }
        else if (b.extras_type === 'wide') { label = `Wd${b.extras_runs > 1 ? '+' + (b.extras_runs - 1) : ''}`; cls = 'bg-amber-400 text-white'; }
        else if (b.extras_type === 'no_ball') { label = `Nb${b.extras_runs > 1 ? '+' + (b.extras_runs - 1) : ''}`; cls = 'bg-orange-400 text-white'; }
        else if (b.extras_type === 'bye') { label = `b${b.extras_runs}`; cls = 'bg-emerald-300 text-emerald-900'; }
        else if (b.extras_type === 'leg_bye') { label = `lb${b.extras_runs}`; cls = 'bg-teal-300 text-teal-900'; }
        else if ((b.runs_scored || 0) === 0) { label = '•'; cls = 'bg-gray-200 text-gray-500'; }

        return (
          <button
            key={b.id}
            onClick={() => onBallClick && onBallClick(b)}
            className={`min-w-[28px] h-7 px-2 rounded-full text-xs font-bold flex items-center justify-center transition-transform hover:scale-110 ${cls}`}
            data-testid={`over-pill-${b.ball_sequence}`}
            title={b.commentary || ''}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
